define('modules/templates/views/template_list',['require','exports','module','base/collectionview','./template_item','./modal_preview','common/models/appstate','backbone','ldsh!../templates/templates_list'],function (require, exports, module) {
  'use strict';
  var CollectionView = require('base/collectionview'),
      TemplateItemView = require('./template_item'),
      PreviewModal = require('./modal_preview'),
      AppState = require('common/models/appstate'),
      Backbone = require('backbone');

  module.exports = CollectionView.extend({
    template: require('ldsh!../templates/templates_list'),
    itemView: TemplateItemView,
    itemContainer: '.js-container',
    attributes: {id: 'templatePicker'},

    initialize: function (options) {
      this.platform = options.platform;
      this.newPage = options.newPage;
      this.allPlatforms = options.allPlatforms;
      this.listenTo(this.childVent, 'template:select', this.selectTemplate);
      this.listenTo(this.childVent, 'template:preview', this.previewTemplate);
    },

    selectTemplate: function (itemView) {
      var self = this;
      this.newPage.templateId = itemView.model.id;
      this.newPage.url = this.newPage.getCreateFromTemplateUrl(this.allPlatforms);
      this.newPage.save(null, {
        success: function (model) {
          //go to editor!
          self.redirectToEditor(model.id);
        },
        error: function () {
          alert('An error has ocurred');
        }
      });
    },

    previewTemplate: function (itemView) {
      var self = this;
      var preview = new PreviewModal({
        model: itemView.model
      });
      preview.once('template:select', function (modalView) {
        preview.hide();
        self.selectTemplate(modalView);
      });
    },

    helpers: function () {
      return {
        pageName: this.newPage ? this.newPage.get('name') : 'DEBUG',
        platform: this.platform
      };
    },

    onRender: function () {
      this.$el.i18n();
    },

    redirectToEditor: function (pageId) {
      Backbone.history.navigate('/editor/' + pageId, {trigger: true, replace: true});
    }
  });
});

